export const DOCUMENT_CATEGORIES = [
    {
        id: 1,
        name: 'Policy',
        description: 'policy'
    }
]